import { BOTH_TYPE, CZK, FREE, IN_PERSON_TYPE } from './misc/consts';

export const formatedDay = (date) => formatedDate(date, { day: 'numeric' });

export const formatedWeekday = (date) =>
  formatedDate(date, { weekday: 'long' });

export const formatedMonth = (date) => formatedDate(date, { month: 'long' });

export const formatedYear = (date) => formatedDate(date, { year: 'numeric' });

export const formatedDate = (date, options = {}) => {
  let fomatedDate = new Date(date);
  return fomatedDate.toLocaleDateString(locale(), options);
};

export const locale = () => document.documentElement.lang;

export const stopScrolling = () => {
  document.body.classList.add('stop-scrolling');
};

export const formatedMoney = (czk) => {
  return `${parseInt(czk).toLocaleString(locale())} Kč`;
};

// Shared by cart.js and nav-cart.js so the checkout page and the nav cart
// badge round the same way (Math.round, not parseInt/truncation) and never
// drift apart. Unlike formatedMoney() above, this shows "Zdarma" when both
// the CZK and EUR amounts are zero.
export const formatedMoneyWithFree = (czk, eur) => {
  if (Math.round(czk) === 0 && Math.round(eur) === 0) {
    return FREE;
  }
  return `${Math.round(czk).toLocaleString(locale())} ${CZK}`;
};

export const startScrolling = () =>
  document.body.classList.remove('stop-scrolling');

export const truncateString = (string = '', maxLength = 50) =>
  string.length > maxLength ? `${string.substring(0, maxLength)}...` : string;

// Simple translation function for time units
const getTimeTranslation = (key) => {
  const currentLocale = locale();
  const translations = {
    cs: {
      hour: 'hodina',
      hours: 'hodiny',
      hours_plural: 'hodin',
      day: 'den',
      days: 'dny',
      days_plural: 'dnů',
    },
    en: {
      hour: 'hour',
      hours: 'hours',
      hours_plural: 'hours',
      day: 'day',
      days: 'days',
      days_plural: 'days',
    },
    sk: {
      hour: 'hodina',
      hours: 'hodiny',
      hours_plural: 'hodín',
      day: 'deň',
      days: 'dni',
      days_plural: 'dní',
    },
    it: {
      hour: 'ora',
      hours: 'ore',
      hours_plural: 'ore',
      day: 'giorno',
      days: 'giorni',
      days_plural: 'giorni',
    },
    uk: {
      hour: 'година',
      hours: 'години',
      hours_plural: 'годин',
      day: 'день',
      days: 'дні',
      days_plural: 'днів',
    },
  };

  return translations[currentLocale]?.[key] || translations['cs'][key] || key;
};

export const tcDays = (duration, customDuration) => {
  if (customDuration > 0) {
    if (customDuration === 1) {
      return `${customDuration} ${getTimeTranslation('hour')}`;
    }
    if (customDuration > 1 && customDuration <= 4) {
      return `${customDuration} ${getTimeTranslation('hours')}`;
    }
    return `${customDuration} ${getTimeTranslation('hours_plural')}`;
  }
  if (duration === 1) {
    return `${duration} ${getTimeTranslation('day')}`;
  }
  if (duration > 1 && duration <= 4) {
    return `${duration} ${getTimeTranslation('days')}`;
  }
  return `${duration} ${getTimeTranslation('days_plural')}`;
};

export const formatedPlace = (event_type, city) => {
  if (event_type === BOTH_TYPE) {
    return `<strong>${city}</strong> <small>nebo</small> <span>Online</span>`;
  } else if (event_type === IN_PERSON_TYPE) {
    return `<strong> ${city} </strong>`;
  } else {
    return '<span>Online</span>';
  }
};

export const initInputs = () => {
  var inputTypes = ['email', 'number', 'password', 'tel', 'text'];
  $('.form-element').each(function () {
    if ($('> input', this).length) {
      floatingLabel($('> input', this));
    }
    if ($('> textarea', this).length) {
      floatingLabel($('> textarea', this));
    }
    if ($('select', this).length) {
      $(this).addClass('form-element--floating');
    }
  });

  $('input, textarea').on('change keyup focusout reset', function (e) {
    if (
      $(this).prop('tagName') === 'TEXTAREA' ||
      inputTypes.includes($(this).attr('type'))
    ) {
      floatingLabel($(this));
    }
  });
  $('input, textarea').on('focusin', function (e) {
    if (
      $(this).prop('tagName') === 'TEXTAREA' ||
      inputTypes.includes($(this).attr('type'))
    ) {
      $(this).closest('.form-element').addClass('form-element--floating');
    }
  });
};
